<div
  *ngIf="dataModel != null"
  [ngClass]="{
      'algo-panel__container' : true,
      'hidden': fatalError || isInitializing || isLoadingScreen
    }"
  [style.max-height.px]="scrollMaxHeight"
  #outerContainer
>
  <div class="algo-panel__inner_container">
    <ng-container *ngFor="let rowData of dataModel.layoutStructure">
      <div
        *ngIf="rowData != null && (rowData[0] != null || rowData[1] != null)"
        class="icd__base__row"
        [ngClass]="{'hidden': (rowData[0] == null || !rowData[0].visible) && (rowData[1] == null || !rowData[1].visible)}"
      >
        <!-- LEFT Position -->
        <div
          *ngIf="rowData[0] != null"
          class="icd-component-wrapper icd-component-wrapper-left"
          [ngClass]="{'hidden': !rowData[0].visible}"
        >
          <ng-template #algoParamsContainer>
            <!-- 	Element: id: {{rowData[0].id}} | type: {{rowData[0].type}} -->
          </ng-template>
        </div>
        <div
          class="icd-component-wrapper icd-component-wrapper-left"
          *ngIf="rowData[0] == null || !rowData[0].visible"
        ></div>
        <!-- RIGHT Position -->
        <div
          *ngIf="rowData[1] != null"
          class="icd-component-wrapper icd-component-wrapper-right"
          [ngClass]="{'hidden': !rowData[1].visible}"
        >
          <ng-template #algoParamsContainer> </ng-template>
        </div>
        <div
          class="icd-component-wrapper icd-component-wrapper-right"
          *ngIf="rowData[1] == null || !rowData[1].visible"
        ></div>
      </div>
    </ng-container>
  </div>
</div>
<div [ngClass]="{'hidden': !isInitializing || fatalError}">Initializing...</div>
<div
  class="algo-panel__container__initialize_embedded"
  [ngClass]="{'hidden': !isInitializingEmbedded || fatalError}"
>
  Initializing...
</div>
<div [ngClass]="{'hidden': !isLoadingScreen || fatalError}">Loading...</div>
<div [ngClass]="{'hidden': !fatalError}">The selected algo strategy is Invalid!</div>
